"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _components = require("./components");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 50;

var LeaderboardOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LeaderboardOverview, _Component);

  var _super = _createSuper(LeaderboardOverview);

  function LeaderboardOverview(props) {
    var _this;

    (0, _classCallCheck2.default)(this, LeaderboardOverview);
    _this = _super.call(this, props);
    _this.state = {
      usersList: [],
      totalPages: 0,
      currentPage: DEFAULT_PAGE,
      currentUser: undefined,
      period: props.period,
      isLoading: false,
      loggedInUserId: props.loggedInUserId
    };
    _this.fetchLeaderboard = _this.fetchLeaderboard.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetchLoggedInLeaderboardUser = _this.fetchLoggedInLeaderboardUser.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetchData = _this.fetchData.bind((0, _assertThisInitialized2.default)(_this));
    _this.generateNextUrl = _this.generateNextUrl.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(LeaderboardOverview, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var period, params, page, pageParam;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                period = this.state.period;
                params = new URLSearchParams(window.location.search);
                page = '1';
                pageParam = params.get('page');

                if (pageParam && params.get('period') === period) {
                  page = pageParam;
                }

                _context.next = 7;
                return this.fetchData(this.props.period, parseInt(page));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(period) {
        var page,
            fetchLoggedInUserSection,
            _yield$Promise$all,
            _yield$Promise$all2,
            leaderboard,
            currentUser,
            result,
            totalPages,
            currentPage,
            _args2 = arguments;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                page = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : DEFAULT_PAGE;

                if (period !== this.state.period) {
                  window.history.pushState(null, '', 'leaderboard');
                }

                this.setState({
                  period: period,
                  isLoading: true
                });
                fetchLoggedInUserSection = !this.props.isGuest && page === 1;
                _context2.next = 6;
                return Promise.all([this.fetchLeaderboard(page), fetchLoggedInUserSection ? this.fetchLoggedInLeaderboardUser() : undefined]);

              case 6:
                _yield$Promise$all = _context2.sent;
                _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 2);
                leaderboard = _yield$Promise$all2[0];
                currentUser = _yield$Promise$all2[1];
                result = leaderboard.result, totalPages = leaderboard.totalPages, currentPage = leaderboard.currentPage;
                this.setState({
                  usersList: result,
                  totalPages: totalPages,
                  currentPage: currentPage,
                  currentUser: currentUser,
                  isLoading: false
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchData(_x) {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }()
  }, {
    key: "fetchLeaderboard",
    value: function () {
      var _fetchLeaderboard = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var page,
            res,
            _args3 = arguments;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                page = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : DEFAULT_PAGE;
                _context3.prev = 1;
                _context3.next = 4;
                return _axios.default.get('/leaderboard/fetch', {
                  params: {
                    period: this.state.period,
                    page: page,
                    pageSize: DEFAULT_PAGE_SIZE
                  }
                });

              case 4:
                res = _context3.sent;

                if (!res.data) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", res.data);

              case 7:
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);
                return _context3.abrupt("return", []);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 9]]);
      }));

      function fetchLeaderboard() {
        return _fetchLeaderboard.apply(this, arguments);
      }

      return fetchLeaderboard;
    }()
  }, {
    key: "fetchLoggedInLeaderboardUser",
    value: function () {
      var _fetchLoggedInLeaderboardUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var res;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _axios.default.get('/leaderboard/fetchUser', {
                  params: {
                    period: this.state.period
                  }
                });

              case 3:
                res = _context4.sent;

                if (!(Object.keys(res.data).length !== 0)) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt("return", res.data);

              case 6:
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", undefined);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));

      function fetchLoggedInLeaderboardUser() {
        return _fetchLoggedInLeaderboardUser.apply(this, arguments);
      }

      return fetchLoggedInLeaderboardUser;
    }()
  }, {
    key: "generateNextUrl",
    value: function generateNextUrl(newPage) {
      var period = this.state.period;
      var baseUrl = '/leaderboard';
      var newPagination = newPage === 1 ? "?period=".concat(period) : "?period=".concat(period, "&page=").concat(newPage);
      return "".concat(window.location.origin).concat(baseUrl).concat(newPagination);
    }
  }, {
    key: "render",
    value: function render() {
      var isGuest = this.props.isGuest;
      var _this$state = this.state,
          usersList = _this$state.usersList,
          totalPages = _this$state.totalPages,
          currentPage = _this$state.currentPage,
          currentUser = _this$state.currentUser,
          isLoading = _this$state.isLoading,
          loggedInUserId = _this$state.loggedInUserId;
      var isLeaderboardEmpty = usersList.length === 0;
      var showCurrentlyLoggedInUserSection = !isGuest && currentPage === 1;
      return (0, _preact.h)("div", {
        className: "leaderboard-page"
      }, !isLoading && isLeaderboardEmpty && (0, _preact.h)(_components.LeaderboardEmptyMessage, null), isLoading || isLeaderboardEmpty ? (0, _preact.h)(_components.LeaderboardSkeleton, {
        isLoading: isLoading
      }) : null, !isLoading && !isLeaderboardEmpty && (0, _preact.h)(_components.LeaderboardUserListTable, {
        usersList: usersList,
        showCurrentlyLoggedInUserSection: showCurrentlyLoggedInUserSection,
        currentUser: currentUser,
        loggedInUserId: Number(loggedInUserId),
        totalPages: totalPages,
        currentPage: currentPage,
        generateNewUrl: this.generateNextUrl
      }));
    }
  }]);
  return LeaderboardOverview;
}(_preact.Component);

var _default = LeaderboardOverview;
exports.default = _default;